import BaseMeasureOverlay from "./BaseMeasureOverlay";

class LineAngleMeasureOverlay extends BaseMeasureOverlay {

	setLayer = (layer) =>
		this.layer = layer;

	onGeometryChange = (event) => {
		// 1. get all the features that are linestrings
		// 2. get coordinates of all those features
		// 3. make line equations for all these features and check whether snap point satisfies any
		// 4. if any satisfied find angle between snap line and the line which we snapped to
		// 5. return the angle
		let coordinates = event.target.getCoordinates();
		let position = coordinates[1];
		let coords_lines = this.layer.getSource().getFeatures()
			.filter(feature => feature.getGeometry().getType() === "LineString")
			.map(feature => feature.getGeometry().getCoordinates());

		let found_any = false;
		for (let i = 0; i < coords_lines.length; i++) {
			let line = coords_lines[i];
			let point1 = line[0];
			let point2 = line[1];
			let x1 = point1[0]
			let y1 = point1[1]
			let x2 = point2[0]
			let y2 = point2[1]
			let snap_point = coordinates[1]
			let a = snap_point[0]
			let b = snap_point[1]

			if (((b - y1) * (x2 - x1)).toFixed(2) === ((y2 - y1) * (a - x1)).toFixed(2)) {
				found_any = true;
				let p = coordinates[0]
				let c = p[0]
				let d = p[1]
				let ms = (d - b) / (c - a)
				let ml = (y2 - y1) / (x2 - x1)
				let anglerad = Math.atan((ms - ml) / (1 + ms * ml))
				let angledeg = (anglerad * 180) / Math.PI
				if (Math.abs(angledeg) > 89) {
					angledeg = 90
				}
				this.overlay.setPosition(position);
				if (String(Math.ceil(angledeg)) !== "NaN")
					this.overlay.element.innerHTML = '<p style="color: DarkBlue; font-weight: bold; font-size:15px; ' +
						'margin-bottom: -10px;text-shadow: 0 0 5px white">' +
						Math.ceil(angledeg) + '&#176' + '</p>';
				else
					this.overlay.element.innerHTML = '';
				// overlay.element.innerHTML='<p style="color: DarkBlue; font-weight: bold; font-size:15px; margin-botton: -10px;text-shadow: 0 0 5px white">'+parseInt(Math.ceil(angledeg))+ '&#176'+ '</p>';
				let angle = Math.ceil(angledeg)
				if (Math.abs(angle) >= 85 && Math.abs(angle) !== 90) {
					let slope = (y2 - y1) / (x2 - x1);
					let na = (d + (c / slope) + (x1 * slope) - y1) / (slope + (1 / slope))
					let nb = (slope * (na - x1)) + y1
					event.target.setCoordinates([coordinates[0], [na, nb]]);
					return [na, nb];
				}
			}
		}
		if (!found_any) {
			this.overlay.setPosition(position);
			this.overlay.element.innerHTML = ''
		}
		return []
	}
}

export default LineAngleMeasureOverlay;
